import styled from 'styled-components'
import Box from '@mui/material/Box'
import { Table } from '@mui/material'

export const StyledCustomTableWrapper = styled(Box)`
`

export const StyledCustomTable = styled(Table)`
    border-collapse: separate !important;
    background: white;
    margin-top: 8px;
    margin-bottom: 8px;
    width: 100%;
    overflow-x: auto;
    border-radius: 8px;
    border: 1px solid #E0E2E2;
    font-family: Proxima Nova;

    & thead {
      font-size: 12px;
    }

    & tbody {
      font-size: 14px;
    }
`
